import assignToCurator from "~/store/graphql/mutations/assignToCurator.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

export default async function (_, { itemId, email }) {
  return await runGraphQLQuery(assignToCurator, { itemId, email }, this.$axios);
}
